import React from 'react';
import styled, { keyframes } from 'styled-components';
import { _ } from '_locales';
import { connect } from 'react-redux';
import { Button } from '../../components';
import { cdnBaseUrl } from '../../../../app/apis';

const BlogList = ({
  blogs, learnMoreButtonClickHandler, windowsWidth, colors
}) => {
  const { main_color } = colors;
  return (
    <Container>
      {blogs.map((item, index) => (
        <BlogContainer windowsWidth={windowsWidth}>
          <ImageContainer windowsWidth={windowsWidth}>
            <Image
              src={`${cdnBaseUrl}/blog_gallery/${item.image_path}`}
              alt={`${item.title || 'Blog post'} preview image`}
            />
          </ImageContainer>
          <ContextContainer>
            <ContextTitle
              windowsWidth={windowsWidth}
              onClick={() => learnMoreButtonClickHandler(index)}
              id={item.title}
            >
              {item.title}
            </ContextTitle>
            <BlogSummary dangerouslySetInnerHTML={{ __html: item.summary }} />
            <Button
              mainColor={main_color || false}
              onClick={() => learnMoreButtonClickHandler(index)}
              margin="auto 0 0 auto"
              aria-label={`Learn more, ${item.title}`}
              aria-describedby={item.title}
            >
              {_('homePage.learn_more')}
            </Button>
          </ContextContainer>
        </BlogContainer>
      ))}
    </Container>
  );
};

export default connect((state) => ({
  colors: state.config.templateColour ? JSON.parse(state.config.templateColour) : {},
}), null)(BlogList);

const OpacityAnimation = keyframes`
  from {opacity: 0;}
  to {opacity: 1;}
`;

const Container = styled.div`
  animation: ${OpacityAnimation} 0.5s;
`;

const ContextContainer = styled.div`
  display:flex;
  flex-direction: column;
  flex: 1;
  margin-left: 20px !important;
  border-bottom: 2px solid #E7ECEF;
  padding: 10px 0;
  overflow:hidden;
`;

const BlogContainer = styled.div`
  display: flex;
  flex-direction: ${({ windowsWidth }) => windowsWidth < 650 && 'column'};
  padding: 0 7px;
  margin: 0 8px;
  margin-bottom: 15px;
  transition: all 0.3s;
  border-radius: 5px;

  &:hover {
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
    ${ContextContainer} {
      border-color: transparent;
    }
  }
`;

const ImageContainer = styled.div`
  padding: 10px 0;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Image = styled.img`
  height: 140px;
  max-width: 140px;
  border-radius: 3px;
`;

const BlogSummary = styled.div`
  width: 100%;
  text-align: left !important;
  & p {
    color: #404040;
    font-size: 16px !important;
    font-family: Roboto, sans-serif !important;
    opacity: 0.8;
    text-align: left !important;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3; /* number of lines to show */
    line-clamp: 3;
    -webkit-box-orient: vertical;
  }
`;

const ContextTitle = styled.h3`
  margin: 0 !important;
  font-size: 16px !important;
  color: #404040 !important;
  font-weight: 600 !important;
  letter-spacing: 1px;
  font-family: Roboto, sans-serif !important;
  cursor: pointer;
  text-align: left !important;
`;
